<template>
    <div>
        <ul class="flex flex-wrap">
            <li v-for="item in list" class="flex max-lg:flex-col w-full lg:w-1/2 p-2 items-center">
                <UiComponentTypography
                    class-name="max-lg:w-full border border-amazon-200 max-lg:border-b-0 lg:border-l-0 bg-amazon-50 py-2 px-4 max-lg:rounded-t lg:rounded-r w-1/3 flex items-center gap-2 max-lg:text-xs"
                >
                    <UIcon v-if="item.icon" :name="item.icon" dynamic class="w-5 h-5 text-amazon-500" />
                    {{ item.name }}
                </UiComponentTypography>
                <UiComponentTypography
                    class-name="max-lg:w-full py-2 px-4 border border-amazon-200 max-lg:rounded-b lg:rounded-l max-lg:border-t-0 lg:border-r-0 grow"
                >
                    {{ item.value }}
                </UiComponentTypography>
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>
import type { PropType } from "vue";
import type { IProductAttribute } from "~/libs/types/api/product";

const props = defineProps({
    list: Array as PropType<IProductAttribute[]>,
});
</script>

<style></style>
